import type { TOC } from '@ember/component/template-only'
import { ContentTile } from 'teacher-ui-client/components/tiles/content'
import { ContentfulEdit } from 'teacher-ui-client/components/contentful/edit'
import { EntriesButtonDownload } from 'teacher-ui-client/components/tiles/entries/button-download'
import { EntriesButtonVideo } from 'teacher-ui-client/components/tiles/entries/button-video'

interface Args {
  coverUrl?: string
  entryId: string
  title: string
  description?: string
  fileUrl?: string
  videoUrl?: string
}

interface Signature {
  Args: Args
  Element: Element
}

export const TilesPrecinctResourceEntry: TOC<Signature> = <template>
  <ContentTile class="flex flex-col p-6" ...attributes>
    <ContentfulEdit class="ml-auto" @entryId={{@entryId}} />
    <div class="mb-4 space-y-2">
      {{#if @coverUrl}}<img
          src={{@coverUrl}}
          alt={{@title}}
          class="border-dusty-black-100 mx-auto h-40 border"
        />{{/if}}
      <p class="text-center font-bold">{{@title}}</p>
      {{#if @description}}
        <p class="text-center">{{@description}}</p>
      {{/if}}
    </div>

    <div class="mt-auto text-center">
      <EntriesButtonDownload @href={{@fileUrl}} />
      <EntriesButtonVideo @href={{@videoUrl}} />
    </div>
  </ContentTile>
</template>

export default TilesPrecinctResourceEntry
